import { SelectOption } from '@common/types/common';
import { api } from '@services/api';

const countriesApi = api.injectEndpoints({
    endpoints: (builder) => ({
        getCountries: builder.query<SelectOption[], void>({
            query: () => 'public/countries/',
            providesTags: ['Countries'],
            transformResponse: (response) => {
                const countries = new Set();
                const uniqueCountries = (response as { name: string; code: string }[])
                    .map((x) => ({
                        label: x.name,
                        value: x.code,
                    }))
                    .filter(({ label }) => !countries.has(label) && countries.add(label)); // Avoid duplicate country entry
                return uniqueCountries;
            },
        }),
        getLanguages: builder.query<{ code: string; name: string }[], void>({
            query: () => 'public/countries/languages/',
            providesTags: ['Languages'],
        }),
    }),
});

export const { useGetCountriesQuery, useGetLanguagesQuery } = countriesApi;
export default countriesApi;
